import { UserRole } from '../types/user.types.js';

export const USER_ROLE_LABELS = {
  [UserRole.GUEST]: '用户',
  [UserRole.HOST]: '活动组织者',
  [UserRole.ADMIN]: '管理员',
} as const;

export const USER_PERMISSIONS = {
  [UserRole.GUEST]: ['view_activities', 'book_activities', 'manage_own_profile'],
  [UserRole.HOST]: [
    'view_activities',
    'book_activities',
    'manage_own_profile',
    'create_activities',
    'manage_own_activities',
    'view_own_bookings',
  ],
  [UserRole.ADMIN]: ['*'], // All permissions
} as const;
